import React, { useContext } from 'react';
import StatusBadge from './StatusBadge';
import StatusBadgeWithInfo from './StatusBadgeWithInfo';
import StatusBadgeInfoContext from './StatusBadgeInfoContext';

interface FlaggedStatusBadgeProps {
  status: string;
  statusType: string;
}

const FlaggedStatusBadge: React.FC<FlaggedStatusBadgeProps> = props => {
  const Badge = useContext(StatusBadgeInfoContext)
    ? StatusBadgeWithInfo
    : StatusBadge;
  return <Badge {...props} />;
};

export default FlaggedStatusBadge;
